document.addEventListener("DOMContentLoaded", function () {
    const botonesModal = document.querySelectorAll("[data-target]");
    const modales = document.querySelectorAll(".modal");
  
    botonesModal.forEach((boton) => {
      boton.addEventListener("click", () => {
        const modalId = boton.getAttribute("data-target");
        const modal = document.querySelector(modalId);
        modal.style.display = "block";
      });
    });
  
    modales.forEach((modal) => {
      const cerrarModal = modal.querySelector(".cerrar-modal");
      cerrarModal.addEventListener("click", () => {
        modal.style.display = "none";
      });
  
      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.style.display = "none";
        }
      });
    });
  });

  